// removed by extract-text-webpack-plugin
module.exports = {"wrap-list-menu-footer":"wrap-list-menu-footer","title-menu-footer":"title-menu-footer","menu-footer":"menu-footer","item-link":"item-link"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-footer/_ListMenuFooter.scss
// module id = ./components/layouts/master/sub-footer/_ListMenuFooter.scss
// module chunks = 0